import el from "@cypherpotato/el";
import { Icon } from "./icon";
import { Paragraph } from "./text";

export function Playground(...children) {
    return el("div.playground[height-target][redrawable]",
        ...children,
        {
            mount() {
                this.redraw();
            },
            $functions: {
                redraw() {
                    const screenHeight = window.innerHeight;
                    const offsetTop = this.getBoundingClientRect().top;
                    this.style.height = Math.max(0, screenHeight - offsetTop) + "px";
                }
            }
        }
    );
}

export function PlaygroundAside(...children) {
    return el("div.playground-aside",
        ...children
    );
}

export function PlaygroundAsideContainer(...children) {
    return el("div.playground-aside-container",
        ...children
    );
}


export function PlaygroundContent(...children) {
    return el("div.playground-content",
        ...children
    );
}

export function PlaygroundDefault(icon, text) {
    return el("div.playground-default",
        Icon(icon),
        Paragraph(text)
    );
}
